var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage-description"},[_c('div',{staticClass:"homepage-desc_content"},[_c('p',{staticClass:"homepage-desc_content_text"},[_vm._v(_vm._s(_vm.textarea))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }